import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
// import { Basecomponent } from 'src/app/directives/basecomponent.directive';
// import { BaseService } from 'src/app/services/base.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { DRTOConstants } from 'src/app/utils/drtoconstants';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../providers/api.service';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { debounceTime } from 'rxjs/operators';
import { SharedService } from 'src/app/providers/shared.service';

@Component({
  selector: 'sm-link-qr',
  templateUrl: './link-qr.component.html',
  styleUrls: ['./link-qr.component.scss']
})
export class LinkQRComponent implements OnInit {

  linkQRCodeForm : FormGroup;
  filteredList: any[] = []

formattedAddress: any = ''
city: string = '';
state: string = '';
country: string = '';
discountType:Boolean = false;
entityHash: any = ''
  isMerchantSpecific:Boolean=false;
  isLocationSpecific:Boolean=false;
  isAllMerchant:Boolean=false;
  selectedMerchant:any=[];
  suggestedMerchant:any=[];
  isMerchantSelected:Boolean=false;
  entityList: any[] = [];
  objectoptions = [
    {name: 'angular'},
    {name: 'aise'}
  ]
  
  private apiSubscription: Subscription = new Subscription();
  constructor(public dialog: MatDialogRef<LinkQRComponent>, private _apiservice: ApiService, private router: Router, private sharedService: SharedService, @Inject(MAT_DIALOG_DATA) public parentData: any) { 
    this.linkQRCodeForm = new FormGroup({

      'code' : new FormControl(null,[Validators.required]),
    
  });


  }



  ngOnInit(): void {
  console.log(this.parentData.data);
  
   
    
  }

 



  linkQR(){
    console.log(this.linkQRCodeForm.value);
    
    let data = {
      businessHashId:this.parentData.data[0].hashId,
      code: this.linkQRCodeForm.value.code,
      bookingType: this.parentData.data[0].qrBookingtype
    }

    this._apiservice.linkQRCode(data);
    this.dialog.close();
    setTimeout(() => {
      this.sharedService.sendClickEvent();
    }, 2000);

  }

  


 



  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }


}
